let colors = {
	primary: '#ff0000',
	success: '#28a745',
	danger: '#dc3545',
	warning: '#ffc107',
	dark: '#343a40',
};

// CONFIGS
/*const themeConfig = {
  disableCustomizer : false,       // options[Boolean] : true, false(default)
  disableThemeTour  : true,        // options[Boolean] : true, false(default)
  footerType        : "static",    // options[String]  : static(default) / sticky / hidden
  hideScrollToTop   : false,       // options[Boolean] : true, false(default)
  mainLayoutType    : "vertical",  // options[String]  : vertical(default) / horizontal
  navbarColor       : "#fff",      // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
  navbarType        : "floating",  // options[String]  : floating(default) / static / sticky / hidden
  routerTransition  : "zoom-fade", // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
  rtl               : false,       // options[Boolean] : true, false(default)
  sidebarCollapsed  : false,       // options[Boolean] : true, false(default)
  theme             : "light",     // options[String]  : "light"(default), "dark", "semi-dark"
  // Not required yet - WIP
  userInfoLocalStorageKey: "userInfo",
  // NOTE: themeTour will be disabled in screens < 1200. Please refer docs for more info.
}*/

const themeConfig = {
	disableCustomizer: true, // options[Boolean] : true, false(default)
	disableThemeTour: true, // options[Boolean] : true, false(default)
	footerType: "static", // options[String]  : static(default) / sticky / hidden
	hideScrollToTop: false, // options[Boolean] : true, false(default)
	mainLayoutType: "vertical", // options[String]  : vertical(default) / horizontal
	navbarColor: "#10163a", // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
	navbarType: "floating", // options[String]  : floating(default) / static / sticky / hidden
	routerTransition: "zoom-fade", // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
	rtl: false, // options[Boolean] : true, false(default)
	sidebarCollapsed: false, // options[Boolean] : true, false(default)
	theme: "semi-dark", // options[String]  : "light"(default), "dark", "semi-dark"
	// Not required yet - WIP
	userInfoLocalStorageKey: "userInfoSite",
	// NOTE: themeTour will be disabled in screens < 1200. Please refer docs for more info.
	checkLoggedUserInterval: (300 * 1000),
	//checkLoggedUserInterval: (10 * 1000),
	userDefaultRole: 'public'
};

import Vue from 'vue';
import Vuesax from 'vuesax';
Vue.use(Vuesax, {
	theme: {
		colors
	},
	rtl: themeConfig.rtl
});

export default themeConfig;
